// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2XelJ","header":"ReportDetails_header__1kZXS","title":"ReportDetails_title__3Palz","left":"ReportDetails_left__3TAAj"};